import Axios from 'axios'
import { emitConsentRequired } from '@/features/consent/utils/consent-events'

const axios = Axios.create({
  baseURL: process.env.NEXT_PUBLIC_BACKEND_URL,
  headers: {
    'X-Requested-With': 'XMLHttpRequest',
  },
  withCredentials: true,
  withXSRFToken: true
})

// Устанавливаем токен из localStorage при каждом запросе
axios.interceptors.request.use((config) => {
  if (typeof window !== 'undefined') {
    const token = localStorage.getItem('token')
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`
    }
  }
  return config
})

// Скользящая сессия: обновляем срок жизни куки при каждом успешном ответе
let lastCookieRefresh = 0
axios.interceptors.response.use(
  (response) => {
    if (typeof window !== 'undefined') {
      const token = localStorage.getItem('token')
      const now = Date.now()
      // Обновляем куку не чаще одного раза в 5 минут, чтобы не спамить запросами
      if (token && now - lastCookieRefresh > 5 * 60 * 1000) {
        lastCookieRefresh = now
        fetch('/api/auth/set-token', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ token }),
        }).catch(() => {/* игнорируем ошибки обновления куки */})
      }
    }
    return response
  },
  (error) => {
    // 403 `consent_required` — это не «доступ запрещён», а сигнал открыть нужное окно
    // сценария согласия. Состояние согласия лежит прямо в теле, отдельный запрос не нужен.
    const data = error.response?.data

    if (error.response?.status === 403 && data?.code === 'consent_required') {
      emitConsentRequired(data.consent)
      // Метка для вызывающего кода: свой тост показывать не нужно, окно уже открыто.
      error.consentHandled = true
    }

    return Promise.reject(error)
  }
)

export default axios